<template>
  <div class="main">
    <van-empty
      v-if="hasNoGame"
      class="custom-image"
      image="https://static.hzwxbz3.cn/Lianyun/font_end/heziIOS/empty.png"
      description="暂无数据"
    />
    <template v-else>
      <div class="games">
        <GameSelect
          :gameList="gameList"
          :activeGameId="activeGameId"
          @changeActiveGame="handleChangeActiveGame"
        />
      </div>
      <div class="record">
        <div class="record_line record_header">
          <div class="record_time">时间</div>
          <div class="record_desc">抽奖次数明细</div>
          <div class="record_result">中奖结果</div>
        </div>
        <div class="record_list">
          <van-list
            v-model="pageLoading"
            :finished="pageFinished"
            finished-text="没有更多了"
            @load="getGiftList"
          >
            <div
              v-for="rec in recordList"
              :key="rec.id"
              class="record_line record_item"
            >
              <div class="record_time">{{ rec.createTime }}</div>
              <div class="record_desc">抽奖次数 {{ (rec.num > 0 ? '+' : '') + rec.num }}</div>
              <div class="record_result">{{ rec.result || '-' }}</div>
            </div>
          </van-list>
          <van-empty
            v-if="hasFetch && !recordList.length"
            class="custom-image"
            image="https://static.hzwxbz3.cn/Lianyun/font_end/heziIOS/empty.png"
            description="暂无数据"
          />
          <!-- <div class="record_shadow" v-if="recordList.length"></div> -->
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { toLogin, setPageTitle } from "@/bridge/AppJsBridge"
import GameSelect from './gameSelect.vue'
import { List, Empty } from 'vant'
import { getDrawLotteryGamesApi, drawLotteryRecordApi } from '@/apis/wxActivity'
import { getListTotalPage } from '@/libs/utils'

const COUNT_ONE_PAGE = 20
export default {
  components: {
    GameSelect,
    [List.name]: List,
    [Empty.name]: Empty,
  },
  data () {
    return {
      activeGameId: '',
      gameList: [],
      recordList: [],
      pageFinished: false,
      pageLoading: false,
      page: 1,
      hasFetch: false,
      hasGetQueryId: false,
      hasNoGame: false,
    }
  },
  computed: {
    isWx () {
      return this.$route.query.platform * 1 !== 1
    },
    activityId () {
      return this.$route.query.id
    },
    curActiveGame () {
      return this.gameList.find(item => item.gameId === this.activeGameId) || {}
    },
  },
  mounted () {
    setPageTitle('中奖记录')
    this.getGames()
  },
  methods: {
    // 获取活动下游戏会场列表
    getGames () {
      return getDrawLotteryGamesApi({
        activityId: this.activityId,
        type: 2,
      }, !this.isWx).then(res => {
        this.gameList = res.data || []
        if (!this.gameList.length) {
          this.hasNoGame = true
        }
        if (res.data.length) {
          const ids = this.gameList.map(item => item.gameId)
          const firstGameId = this.$route.query.gameId || ids[0]
          this.handleChangeActiveGame(ids.includes(firstGameId * 1) ? this.gameList.find(item => item.gameId === firstGameId) : (this.gameList[0] || {}))
        }
      }).catch((err) => {
        if (err.response && err.response.data.code === 401) {
          toLogin("/loginKey/LoginByKeyPhoneActivity")
        }
      })
    },
    handleChangeActiveGame (game) {
      const { gameId, gameName, enterStatus, placeId } = game
      this.page = 1
      this.pageFinished = false
      this.activeGameId = gameId
      return this.getGiftList()
    },
    getGiftList () {
      const { gameId, gameName, enterStatus, placeId } = this.curActiveGame
      if (!placeId) return Promise.resolve()
      const currentPage = this.page > 1 ? this.page : 1
      this.pageLoading = true
      return drawLotteryRecordApi({
        page: currentPage,
        size: COUNT_ONE_PAGE,
        placeId,
        activityId: this.activityId,
      }, !this.isWx).then(res => {
        const { list = [], total, currentPage: c_page } = res.data; 
        const _list = list || []
        const totalPage = getListTotalPage(total, COUNT_ONE_PAGE);
        if (c_page === 1) {
          this.recordList = _list
        } else {
          this.recordList = this.recordList.concat(_list)
        }
        this.page += 1
        this.hasFetch = true
        if (c_page === totalPage) {
          this.pageFinished = true;
        }
      }).catch(() => {
        this.pageFinished = true;
      })
      .finally(() => {
        this.pageLoading = false
      })
    },
  },
}
</script>

<style scoped lang="scss">
.main  {
  background: #44209c;
  color: #fff;
  width: 100%;
  height: 100vh;
  padding: 0 8px;
  padding-top: calc(18px + 84px + 8px);
  .games {
    position: absolute;
    top: 18px;
    margin-left: 10px;
  }
  .record {
    height: calc(100% - (84px - 12px - 8px));
    margin-top: 12px;
    .record_list {
      position: relative;
      height: calc(100% - 12px);
      overflow: auto;
      // border-radius: 6px;
      // box-shadow: inset 0px 2px 10px -5px rgba(255, 255, 255, 0.6);
    }
    .record_shadow {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 8px;
      background: linear-gradient(0deg, #3333338f 0%, transparent 100%)
    }
    .record_line {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      div {
        width: 110px;
        text-align: center;
      }
    }
    .record_item {
      font-size: 12px;
    }
    .record_header {
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 6px;
      border-bottom: 1px dashed #ffffff8f;
    }
  }
}
</style>